<template>
  <div class="zt-size-provider" tabindex="-1">
    <slot />
  </div>
</template>
<script>
import { throttle } from 'lodash'
export default {
  name: 'ztSizeProvider',
  props: {
    waitOnCallback: {
      type: Number,
      default: 250
    }
  },
  data() {
    return {
      hasObserver: false,
      observer: null,
      size: {
        height: 0,
        width: 0
      }
    }
  },
  mounted() {
    if (!this.hasObserver) {
      this.initObserver()
    }
  },
  methods: {
    _onResize() {
      if (!this.$el || !this.$el.parentNode) return
      const parent = this.$el.parentNode
      const bbox = parent.getBoundingClientRect()
      const size = {
        height: bbox.height,
        width: bbox.width
      }
      if (size.width === this.size.width && size.height === this.size.height)
        return
      this.size = size
      this.$emit('notify', this.size)
    },
    initObserver() {
      this.$nextTick(() => {
        this.observer = new ResizeObserver(
          throttle(this._onResize, this.waitOnCallback)
        )
        this.observer.observe(this.$el.parentNode)
        this.hasObserver = true
      })
    }
  },
  beforeDestroy() {
    try {
      this.observer.unobserve(this.$el.parentNode)
      this.hasObserver = false
      this.observer = null
    } catch (e) {
      console.info(e)
    }
  }
}
</script>
